import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Cheese</title>
                    <meta name="description" content="Simple, natural ingredients make the best food. That’s why we've officially ditched processed cheese. All our cheese—cheddar, jalapeño Monterey Jack, cheese curds and mozzarella—is 100% real and made with 100% Canadian milk." />
                </Helmet>
            :
                <Helmet>
                    <title>Notre Fromage</title>
                    <meta name="description" content="Chez A&W, nous croyons en l’utilisation de vrais ingrédients. C’est pourquoi nous avons officiellement éliminé le fromage transformé. Tous nos fromages – cheddar, Monterey Jack aux jalapenos, mozzarella et en grains – sont 100 % naturels et faits avec du lait 100 % canadien." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;